import { useEffect, useState } from 'react'

export function useDelayedFlag(active: boolean, delayMs = 2000): boolean {
  const [delayed, setDelayed] = useState(false)

  useEffect(() => {
    if (!active) {
      setDelayed(false)
      return
    }

    setDelayed(false)
    const timer = window.setTimeout(() => setDelayed(true), delayMs)
    return () => window.clearTimeout(timer)
  }, [active, delayMs])

  return delayed
}
